import { CommonModule } from '@angular/common';
import { TrimInputDirective } from 'src/app/directives/trim.directive';
import { Component, effect, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { ActionBtnComponent } from 'src/app/shared/components/master-detail-layout/action-btn/action-btn.component';
import { CardComponent } from 'src/app/shared/components/master-detail-layout/card/card.component';
import { PrinterFormService } from '../../../services/printer-form.service';
import { PrintersFormGroups } from '../../../models/settings-printers.model';
import { PrintersModuleService } from '../../../services/printers-module.service';
import { Printers } from 'tilby-models';
import { FONT_SIZE, HEADER_SIZE, ITEM_SPACINGS, ITEMS_ALIGNS, ITEMS_GROUP_BY, LINE_SPACING, printerDriver } from '../../../constants/printer-details.constants';
import { MatSelectModule } from '@angular/material/select';
import { EscPosEncoder } from 'src/app/features/printers/drivers';
import { TilbyDatePipe } from '@tilby/tilby-ui-lib/pipes/tilby-date';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GenericListDialogService } from 'src/app/dialogs';

@Component({
  selector: 'app-printer-settings',
  standalone: true,
  imports: [
    CommonModule,
    TrimInputDirective,
    CardComponent,
    ActionBtnComponent,
    MatFormFieldModule, ReactiveFormsModule,
    MatInputModule, MatSlideToggleModule,
    TilbyDatePipe, MatSelectModule, MatCheckboxModule,
    TranslateModule
  ],
  templateUrl: './printer-settings.component.html',
  styleUrl: './printer-settings.component.scss'
})
export class PrinterSettingsComponent {
  
  protected readonly printerFormService = inject(PrinterFormService);
  private readonly printerModuleService = inject(PrintersModuleService);
  private readonly genericListDialogService = inject(GenericListDialogService);

  protected printerGroupForm!: PrintersFormGroups;
  protected printer: Printers | null = null;

  protected printerDriverList = printerDriver;
  protected codepageMappings = [{ name: 'Raster', value: 'raster' }, ...EscPosEncoder.getAvailableCodepageMappings()]
  protected availableDocs = this.printerModuleService.printerDocumentTypes;
  protected lineSpacingList = LINE_SPACING;
  protected itemSpacingsList = ITEM_SPACINGS;
  protected itemsAlignsList = ITEMS_ALIGNS;
  protected headerSizeList = HEADER_SIZE;
  protected fontSizeList = FONT_SIZE;
  protected itemsGroupByList = ITEMS_GROUP_BY;

  protected linearLabelClass = "tw-font-medium tw-text-[var(--sys-secondary-text)]";
  protected linearValueClass = "tw-font-medium tw-text-[var(--sys-text)]";
  protected priceLabelClass = "tw-text-[12px] tw-font-bold tw-tracking-wider tw-text-[var(--sys-secondary-text)] tw-mb-1";
  protected priceValueClass = "tw-text-sm tw-font-medium tw-text-[var(--sys-text)]";

  constructor() {
    effect(() => {
      if(this.printerFormService.printerFormReady()) {
        this.printerGroupForm = this.printerFormService.form;
      }
    })
    effect(() => {
      this.printer = this.printerModuleService.selection()?.printer as Printers;
    })
  }

  copyPrinterSettings = async () => {
    const orderPrinters = (this.printerModuleService.printersMap.get("NONFISCAL") || [])
      .filter(p => p.id !== this.printer?.id);

    const sourcePrinter = await this.genericListDialogService.openDialog({
        data: {
          title: { label: 'PRINTERS.DETAIL.COPY_PRINTER_SELECT' },
          list: orderPrinters.map((p) => ({ name: p.name, value: p, isSelected: false }))
        }
    });

    if(!sourcePrinter) {
      return;
    }

    let printerConfig;

    try {
      printerConfig = JSON.parse(sourcePrinter.configuration || '{}');
    } catch(err) {
      printerConfig = {};
    }

    const { cashregisters, other_printers, rooms, ...configToCopy } = printerConfig;

    const currentPrinter = this.printerModuleService.selection()?.printer as Printers;
    if (currentPrinter) {
      Object.assign(currentPrinter, {
        columns: sourcePrinter.columns,
        configuration: JSON.stringify(configToCopy),
        enable_buzzer: sourcePrinter.enable_buzzer,
        top_space: sourcePrinter.top_space,
        bottom_space: sourcePrinter.bottom_space
      });
    }

    this.printerFormService.form.patchValue({
        settingsForm: {
          columns: sourcePrinter.columns,
          enable_buzzer: sourcePrinter.enable_buzzer,
          top_space: sourcePrinter.top_space,
          bottom_space: sourcePrinter.bottom_space
        },
        // configurationForm: configToCopy
    });

    const newConfigurationGroup = this.printerFormService.buildConfigurationForm(currentPrinter);
    this.printerFormService.form.setControl('configurationForm', newConfigurationGroup);

    const newNonFiscalGroup = this.printerFormService.buildNonFiscalConfigurationForm(currentPrinter);
    this.printerFormService.form.setControl('nonFiscalConfiguration', newNonFiscalGroup);

    // console.log("UPDATED PRINTER ", currentPrinter);
    // console.log("PRINTER from service ", this.printerModuleService.selection())
    // console.log("PRINTER FORM GROUP ", this.printerFormService.form)
  }
}
